/*
 *   File : phoneWithFlag.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : phoneWithFlag.js
 *   Integrations : 
 *   Version : v1.0
 *   Created : 09-12-2021
 */

/*Package importing*/
import React from 'react';
import 'react-phone-number-input/style.css'
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'


/*import style*/
import styles from '../../styles/components/phoneInput.module.scss';
import metadata from 'libphonenumber-js/metadata.full';

export default class PhoneWithFlag extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			error: null,
		}
	}



	/*--- validation for 10 digit number ---*/
	validate() {
		//eslint-disable-next-line
		if (this.state.value && this.state.value.length < 8 || this.state.value === "0000000000") {
			this.setState({ error: "Invalid phone" })
		}
	}

	/* ---- onChange events to pass value ---*/
	valueChange(value, e) {

		this.props.valueChange(value)
	}

	/*---- onpress of enter ---*/
	keyPress(e) {
		if (e.keyCode === 13 && this.props.searchBox) {
			this.props.onSearch();
		}

	}

	getCountryFromCallingCode(code) {
		const countries = metadata.country_calling_codes[code];
		return countries ? countries[0] : null;
	}


	render() {
		const defaultCountry = this.getCountryFromCallingCode(this.props.value || "91");

		return (
			<div className={this.props.isDisabled ? `${styles.e_input_wrap} ${styles.e_input_disabled}` : styles.e_input_wrap}>
				<PhoneInput
					limitMaxLength={true}
					placeholder="Enter phone number"
					value={this.props.value}
					onChange={(value) => { this.valueChange(value) }}
					//eslint-disable-next-line
					className={this.state.error ? `${styles.e_input_error} ${styles.e_input_box}` + " " + this.props.className : `${styles.e_input_box}` + " " + this.props.className}
					defaultCountry={defaultCountry}
					onBlur={() => { this.validate() }}
					international
					countryCallingCodeEditable={false}
				/>

			</div>
		);
	}
}

